import React from "react";
import { useMediaQuery } from "react-responsive";

function DiscoverNewPlace() {
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1366 });
  const isBigScreen = useMediaQuery({ minDeviceWidth: 1824 });
  const isMobileDevice = useMediaQuery({ maxDeviceWidth: 767 });
  const isTabletDevice = useMediaQuery({
    minDeviceWidth: 768,
    maxDeviceWidth: 1224,
  });

  return (
    <div style={{ margin: "0 auto", display: "flex" }}>
      <div style={{ padding: 20, flex: 1, backgroundColor: "#2D357F" }}>
        <br />{" "}
        {isDesktopOrLaptop && (
          <h1 style={{ color: "white", fontWeight: "bold" }}>
            Discover new place
          </h1>
        )}
        {isTabletDevice && (
          <h1 style={{ color: "white", fontWeight: "bold" }}>
            Discover new place
          </h1>
        )}
        {isMobileDevice && (
          <h2 style={{ color: "white", fontWeight: "bold" }}>
            Discover new place
          </h2>
        )}
        <br />
        <p style={{ color: "white" }}>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Placeat
          quisquam, veritatis ducimus, vero magnam hic quia pariatur asperiores
          laudantium quod nobis perspiciatis, expedita quo reprehenderit quasi
          iusto ullam error reiciendis.
        </p>
        <br />
      </div>

      <div
        class="second"
        style={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <div style={{ backgroundColor: "#F5F5F9", flex: 1 }}></div>
        {/* <div class="second-b">B</div> */}
      </div>
    </div>
  );
}

export default DiscoverNewPlace;
